// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 164 ? "chart" : chunkId) + ".bundle.1bbee8efaab3c00fb15a3bac37734620fb54ba08.js";
};